import { createContext } from 'react'

const AlertsContext = createContext(null)

export default AlertsContext
